export interface ProjectStateInfo {
  value: string;
  label: string;
  className: string;
}

export const projectStateConfig: readonly ProjectStateInfo[] = [
  { value: 'APPROVED', label: 'Aprobado', className: 'bg-success-base' },
  { value: 'VALIDATED', label: 'Validado', className: 'bg-success-base' },
  { value: 'PENDING', label: 'Solicitado', className: 'bg-info-base' },
  { value: 'EVALUATING', label: 'En evaluacion', className: 'bg-warning-base' },
  { value: 'REJECTED', label: 'Rechazado', className: 'bg-red-500' },
  { value: 'DEVELOPMENT', label: 'En desarrollo', className: 'bg-warning-base' },
  { value: 'DEVELOPED', label: 'Desarrollado', className: 'bg-success-base' },
  { value: 'DEVELOPED_AND_REVIEWED', label: 'Desarrollado y revisado', className: 'bg-success-base' },
  { value: 'VALIDATED', label: 'Validado', className: 'bg-success-base' },
  { value: 'OPERATION', label: 'En funcionamiento', className: 'bg-primary-base' },
  { value: 'CORRECTION', label: 'Pendiente de subsanación', className: 'bg-alert-base' },
  { value: 'FINALIZED', label: 'Finalizado', className: 'bg-success-dark' },
  { value: 'CANCELED', label: 'Cancelado', className: 'bg-alert-base' },
];

const projectStateFallback: ProjectStateInfo = {
  value: '',
  label: 'Estado desconocido',
  className: 'bg-neutral-dark',
};

const projectStateMapper: Record<string, ProjectStateInfo> = projectStateConfig.reduce<
  Record<string, ProjectStateInfo>
>((states, state) => {
  states[state.value] = state;
  return states;
}, {});

export function getProjectStateInfo(state?: string | null): ProjectStateInfo {
  if (!state) return projectStateFallback;

  const normalizedState = state.toUpperCase();
  return projectStateMapper[normalizedState] ?? { ...projectStateFallback, value: normalizedState };
}

export function getProjectStateFilterOptions(): { label: string; value: string }[] {
  return projectStateConfig.map(({ label, value }) => ({
    label: value === 'PENDING' ? 'Solicitado' : label,
    value,
  }));
}
